module.exports = __webpack_public_path__ + "static/img/200167.774894c0.png";